import React, {Component} from 'react';
import {
  Row,
  Col,
  NavItem,
  Nav,
  NavLink,
  TabPane,
  TabContent,
} from 'reactstrap';

class Tabs extends Component {
  constructor(props) {
    super(props);
 
    this.state = {
      activeTab: "0"
    };
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  navLink(tab, index) {
    return (
      <NavItem key={tab.id}>
        <NavLink
          className={this.state.activeTab == index ? 'active' : ''}
          onClick={() => { this.toggle(index); }}
        >
          {tab.name}
        </NavLink>
      </NavItem>
    );
  };

  renderTab(tab, index) {
    return (
      <TabPane 
        tabId={index} 
        key={tab.id}
        className={this.state.activeTab == index ? 'active' : ''}>
        <Row>
          <Col sm="12">
            {tab.body}
          </Col>
        </Row>
      </TabPane>
    );
  };

  render() {
    return (
      <div>
        <Nav tabs>
          {this.props.tabs.map( (tab, index) => this.navLink(tab, index) )}
        </Nav>
        <TabContent activeTab={this.state.activeTab}>
          {this.props.tabs.map( (tab, index) => this.renderTab(tab, index) )}
        </TabContent>
      </div>
    );
  }
}

export default Tabs;


// WEBPACK FOOTER //
// ./src/components/Tabs/Tabs.js